export const mobileRegex = /^([6-9]{1})([0-9]{9})$/;
export const emailRegex = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,20}$)/
export const alphabetsRegex = /^[a-zA-Z]+$/
export const numberRegex = /^[0-9\b]+$/
export const floatingPointNumberRegex = /^[0-9]*\.?[0-9]*$/